import {getDevicesList} from './getDevicesList';
import {registration} from './registration';
import {disconnect} from './disconnect';

export const deviceService = {
  getDevicesList,
  registration,
  disconnect,
};
